import { api } from './client';
import { endpoints } from './endpoints';

/** Candidate-facing interviews. The company schedule lives in company.api.js. */
export function listInterviews(params) {
  return api.getPaginated(endpoints.interviews.root, { params });
}

export function getInterview(id) {
  return api.get(endpoints.interviews.byId(id));
}

export function respondToInterview(id, response, message) {
  return api.post(endpoints.interviews.respond(id), { response, message });
}

/** Ask the company for another time. The interview itself does not move. */
export function requestReschedule(id, input) {
  return api.post(endpoints.interviews.rescheduleRequest(id), input);
}

export function withdrawRescheduleRequest(id) {
  return api.delete(endpoints.interviews.rescheduleRequest(id));
}
